export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["广告"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["描述"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请求详情"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您给出"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您收到"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["限制"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可用"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["超时"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["分"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["活跃"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["广告链接"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["做市ID"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["做市账户"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建日期"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["仅对已验证用户可用"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["天"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["小时"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开始日期"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结束日期"])}
}